import styled from 'styled-components'

export const ChallengeBadgesColumn = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 0.35rem;
  overflow: visible;
  white-space: normal;
  padding: 0.25rem 0.75rem 0.35rem;
  box-sizing: border-box;

  & > .d-flex {
    width: 100%;
    min-width: 0;
    justify-content: center;
    text-align: center;
    white-space: normal;
  }

  & > .d-flex span {
    max-width: 100%;
    white-space: normal;
    text-align: center;
  }
`

export const ChallengeCardWrapper = styled.div<{ $isClosed?: boolean }>`
  opacity: ${({ $isClosed }) => ($isClosed ? 0.65 : 1)};
  transition: opacity 0.2s ease;
  filter: ${({ $isClosed }) => ($isClosed ? 'grayscale(0.25)' : 'none')};

  .card,
  .card > div,
  .card > div > div:last-child {
    height: auto;
    min-height: 0;
  }

  .card {
    min-height: 24rem;
  }

  .card > div > div:first-child {
    height: 6.5rem;
  }

  div:has(> ${ChallengeBadgesColumn}) {
    height: auto;
    min-height: 4.5rem;
    overflow: visible;
  }

  .card > div > div:last-child > div:last-child {
    height: auto;
    max-height: none;
    padding-bottom: 1rem;
  }
`

export const ChallengeStatusBadge = styled.span<{ $isClosed?: boolean }>`
  display: inline-flex;
  align-items: center;
  background: ${({ $isClosed }) => ($isClosed ? '#e5e7eb' : '#d1fae5')};
  color: ${({ $isClosed }) => ($isClosed ? '#4b5563' : '#065f46')};
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  line-height: 1.2;
`

export const ChallengeCardDescription = styled.div`
  margin-top: 1%;

  padding: 0 1rem;

  display: -webkit-box;
  max-width: 250px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: center;
`

export const ChallengeCardShortDescription = styled.span`
  width: 100%;
  word-break: break-all;

  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
`

export const ChallengeCardLimit = styled.div`
  border-radius: 4px;
  font-weight: 700;
  min-width: max-content;
  opacity: 1;
  font-size: 14px;
  color: var(--risk);
  background-color: var(--background-risk);
  border: 2px solid var(--background-risk);
  height: 32px;
  padding: 4px 16px;
  width: 32px;
`
